import React from "react";
import {ListItem, Paragraph, SectionHeading} from "../PrivacyPolicyText";

const IntroductionSection = () => (
  <>
    <Paragraph>{"Last Updated June 19, 2026"}</Paragraph>

    <SectionHeading>{"Introduction"}</SectionHeading>

    <Paragraph>
      {"Super Money Games Inc., d/b/a Evenplay (“Evenplay,” \"Company,\" \"We,\" or “Us”) respects your privacy and is committed to protecting it through our compliance with this Privacy Policy (this “Policy”)."}
    </Paragraph>

    <Paragraph>
      {"This Policy describes the types of information We may collect from you or that you may provide when you visit the website www.evenplay.com, (our \"Website\"), our mobile applications (“Applications”), including social networking features (collectively “Services and/or Challenges”) and our practices for collecting, using, maintaining, protecting, and disclosing that information."}
    </Paragraph>

    <Paragraph>{"This Policy applies to information We collect:"}</Paragraph>

    <ListItem>{"On our Website or through the Applications;"}</ListItem>

    <ListItem>
      {"In email, text, and other electronic messages between you and Us, whether direct email or text communications or through our Website or the Applications;"}
    </ListItem>

    <ListItem>
      {"Through various means in order to perform Know Your Customer (“KYC”) obligations and verification that it is you; and"}
    </ListItem>

    <ListItem withBottomMargin>
      {"Through other mobile and desktop applications you download from our Website, which provide dedicated non-browser-based interaction between you and us."}
    </ListItem>

    <Paragraph>{"It does not apply to information collected by:"}</Paragraph>

    <ListItem>
      {"Us offline (except as noted above) or through any other means, including on any other website operated by Company or any third party; or"}
    </ListItem>

    <ListItem withBottomMargin>
      {"Any third party, including through any application or content (including advertising) that may link to or be accessible from or on our Website or the Applications."}
    </ListItem>

    <Paragraph>
      {"Please read this Policy carefully to understand our policies and practices regarding your information and how We will treat it. If you do not agree with our policies and practices, your choice is not to use our Services. By accessing or using our Services, you agree to this privacy Policy. This Policy may change from time to time (see Changes to Our Privacy Policy). Your continued use of our Services after We make changes is deemed to be acceptance of those changes, so please check the Policy periodically for updates."}
    </Paragraph>

    <SectionHeading>{"Person Under the Age of 18"}</SectionHeading>

    <Paragraph>
      {"Our Services are not intended for persons under 18 years of age. No one under age 18 may provide any information to Us in connection with our Services. We do not knowingly collect personal information from persons under 18. If you are under 18, do not use or provide any information to Us in connection with Services offered. If We learn We have collected or received personal information from a person under 18 We will delete that information. If We determine that a customer is under the age of 18, We will immediately terminate the associated account and delete any information provided. If you believe We might have any information from or about a person under 18, please contact Us at:"}
    </Paragraph>

    <Paragraph>{"Evenplay, 2575 S Highland Dr, Las Vegas, 89109 or by email at support@evenplay.com"}</Paragraph>

    <Paragraph>
      {"California residents under 16 years of age may have additional rights regarding the collection and sale of their personal information. Please see Your California Privacy Rights for more information. Evenplay does not knowingly collect any information from person under the age of 18."}
    </Paragraph>
  </>
);

export default IntroductionSection;
